import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import pkg from '../../package.json';
import Modal from '../components/common/Modal';

export interface AboutProps {
    isOpen: boolean;
    onClose: () => void;
};

const About:FC<AboutProps> = ({ isOpen, onClose }) => {
	const { t } = useTranslation();

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<h1>{t('about.title')}</h1>
			<div
				dangerouslySetInnerHTML={
					{__html: t('about.about', { 'interpolation': {'escapeValue': false} })}
				}
			/>
			<div className='p'>
				Version: {pkg.version}
			</div>
		</Modal>
	);
};

export default About;
